import { Footer, Loading, TrackingPageHeader } from '@reveni-io/reveni-ui'

import TrackingPageGrid from './TrackingPageGrid/TrackingPageGrid'
import { fadeAnimate, fadeInitial, fadeTransition } from './constants'
import * as Styles from './styles'

const TrackingPagePreview = ({
  orderTrackingPreview,
  viewMode,
  layout,
  blockSettings,
  blockVisibility,
  blockErrors,
  hiddenBlocks,
  showHiddenBlocks,
  timeZone,
  editorContext,
  getRecommendedProductsService,
  onLayoutChange,
  onLayoutChangeStart,
  onLayoutChangeCommit,
  onBlockHeightChange,
  onBlockResize,
  selectedBlockId,
  onSelectBlock,
  onRemoveBlock,
}) => {
  if (!layout) {
    return <Loading show />
  }

  return (
    <>
      <TrackingPageHeader
        logoUrl={orderTrackingPreview.portal.theme.logo_url}
        storeName={orderTrackingPreview.store.name}
      />
      <Styles.FadeContainer key={viewMode} initial={fadeInitial} animate={fadeAnimate} transition={fadeTransition}>
        <TrackingPageGrid
          orderTrackingPreview={orderTrackingPreview}
          viewMode={viewMode}
          layout={layout}
          blockSettings={blockSettings}
          blockVisibility={blockVisibility}
          blockErrors={blockErrors}
          hiddenBlocks={hiddenBlocks}
          showHiddenBlocks={showHiddenBlocks}
          timeZone={timeZone}
          editorContext={editorContext}
          getRecommendedProductsService={getRecommendedProductsService}
          onLayoutChange={onLayoutChange}
          onLayoutChangeStart={onLayoutChangeStart}
          onLayoutChangeCommit={onLayoutChangeCommit}
          onBlockHeightChange={onBlockHeightChange}
          onBlockResize={onBlockResize}
          selectedBlockId={selectedBlockId}
          onSelectBlock={onSelectBlock}
          onRemoveBlock={onRemoveBlock}
        />
      </Styles.FadeContainer>
      <Footer />
    </>
  )
}

export default TrackingPagePreview
